import React from 'react';

const PopupForm = ({ popupConfig, setPopupConfig }) => {
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPopupConfig({
      ...(popupConfig || {}),
      [name]: type === 'checkbox' ? checked : value
    });
  };

  return (
    <div>
      <h2 className="text-xl font-bold text-white mb-4">Popup</h2>
      <label className="block text-white mb-2">
        Visible:
        <input
          type="checkbox"
          name="visible"
          checked={!!popupConfig?.visible}
          onChange={handleInputChange}
          className="ml-2"
        />
      </label>
      <label className="block text-white mb-2">
        Text:
        <input
          type="text"
          name="text"
          value={popupConfig?.text || ""}
          onChange={handleInputChange}
          className="mt-1 p-2 w-full border border-gray-300 rounded bg-white text-black"
        />
      </label>
    </div>
  );
};

export default PopupForm;
